export const PH_KEYS = {
  // User
  USERNAME: "username",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  EMAIL: "email",
  EMAIL_VERIFIED: "emailVerified",
  AUTHENTICATION_METHOD: "authenticationMethod",
  JOB_FUNCTION: "jobFunction",
  SIGNUP_AT: "signupAt",
  CURRENT_PLAN: "currentPlan",
  REFERRAL_METHOD: "referralMethod",

  // Promotions
  PROMO_CODES: "promoCodes",
  SIGNUP_PROMO_CODES: "signupPromoCodes",
  PROMO_CODES_APPLIED_EVENT: "promoCodeAppliedEvent",
  PROMO_CODES_USED_TIMEZONE: "promoCodeUsedTimezone",

  // Workspace
  WORKSPACE_ID: "workspaceId",
  WORKSPACE_NAME: "workspaceName",
  WORKSPACE_CURRENT_PLAN: "workspaceCurrentPlan",
  WORKSPACE_ORIGINAL_PLAN: "workspaceOriginalPlan",
  WORKSPACE_PREVIOUS_PLAN: "workspacePreviousPlan",
  WORKSPACE_CREATED_AT: "workspaceCreatedAt",
  WORKSPACE_LAST_ACTIVE: "workspaceLastActive",
  WORKSPACE_CURRENT_PAYMENT_METHOD: "workspaceCurrentPaymentMethod",
  WORKSPACE_SIGNUP_FREE_ABSTRACTS: "workspaceSignupFreeAbstracts",

  // Transactions
  TRANSACTION_ID: "transactionId",
  FILE_NAME: "fileName",
  FILE_COUNT: "fileCount",
  FILE_SIZE: "fileSize",
  FILE_TYPE: "fileType",
  UPLOAD_METHOD: "uploadMethod",
  FILE_COUNT_TOTAL: "fileCountTotal",
  FILE_SIZE_TOTAL: "fileSizeTotal",
  FILE_TYPES: "fileTypes",
  TRANSACTION_CREATED_AT: "transactionCreatedAt",
  FREE_ABSTRACT_USED: "freeAbstractUsed",
  FREE_ABSTRACTS_USED_COUNT: "freeAbstractsUsedCount",
  TOTAL_COST: "totalCost",

  // Table Actions
  DOCUMENT_ID: "documentId",
  PAGE_NUMBER: "pageNumber",
  ROW_NUMBER: "rowNumber",
  SORT_KEY: "sortKey",
  SORT_DIRECTION: "sortDirection",
  SEARCH_TEXT: "searchText",
  REASON: "reason",

  // Refunds
  NUMBER_OF_DOCUMENTS: "numberOfDocs",
  REFUND_REQUEST_AMOUNT: "refundRequestAmount",
  REFUND_REQUESTED_AT: "refundRequestedAt",
  REFUNDED_AMOUNT: "refundedAmount",

  // Abstracts
  ABSTRACT_ID: "abstractId",
  ABSTRACT_TOTAL_COUNT: "abstractTotalCount",
  NUMBER_OF_TERMS_FOUND: "numberOfTermsFound",
  ABSTRACTION_TIME_SECONDS: "abstractionTimeSeconds",
  SINGLE_DOC_ABSTRACTS_COUNT: "singleDocAbstractsCount",
  MULTI_DOC_ABSTRACTS_COUNT: "multiDocAbstractsCount",
  SINGLE_DOC_ABSTRACTS_FILE_COUNT: "singleDocAbstractsFileCount",
  MULTI_DOC_ABSTRACTS_FILE_COUNT: "multiDocAbstractsFileCount",
  MULTI_DOC_ABSTRACTS_GROUP_COUNT: "multiDocAbstractsGroupCount",
  ABSTRACT_TYPE: "abstractType",
  NUM_OF_FILES: "numOfFiles",
  TOTAL_GROUP_COUNT: "totalGroupCount",
  PROPERTIES_ADDED: "propertiesAdded",
  RENAME_TYPE: "renameType",

  // Downloads
  DOWNLOAD_TYPE: "downloadType",

  // Documents
  PAGES: "pages",

  // Other
  LOCATION: "location",

  // Document Viewer
  DOCUMENT_NAME: "documentName",
  DOCUMENT_TYPE: "documentType",
  DOCUMENT_SEQUENCE: "documentSequence",
  DOCUMENT_MOST_RECENT: "documentMostRecent",
  SOURCE_TERM: "sourceTerm",
  SOURCE_TYPE: "sourceType",
  REFERRAL_LOCATION: "referralLocation",
  BOOKMARK_TOGGLE_STATE: "bookmarkToggleState",
  HIGHLIGHT_TOGGLE_STATE: "highlightToggleState",
  TAG_BOOKMARK_CLICKED: "tagBookmarkClicked",
  PAGE_FROM: "pageFrom",
  PAGE_TO: "pageTo",
  NAVIGATION_METHOD: "navigationMethod",
  ZOOM_VALUE: "zoomValue",
};

export const PH_EVENTS = {
  USER_SIGNED_UP: "User Signed Up",
  EMAIL_VERIFIED: "Email Verified",
  USER_LOGGED_IN: "User Logged In",
  FILES_ADDED: "Files Added",
  FILES_UPLOADED: "File Uploaded",
  FILES_REMOVED: "File Upload Removed",
  FILE_SELECTION_ABANDONED: "File Selection Abandoned",
  CHECKOUT_STARTED: "Checkout Started",
  CHECKOUT_SUCCESSFUL: "Checkout Successful",
  CHECKOUT_ABANDONED: "Checkout Abandoned",
  ABSTRACTION_SUCCESSFUL: "Abstraction Successful",
  ABSTRACTION_FAILED: "Abstraction Failed",
  LANDING_PAGE_ABSTRACT_TABLE_SORTED: "Landing Page - Abstract Table Sorted",
  LANDING_PAGE_ABSTRACT_TABLE_SEARCH: "Landing Page - Abstract Table Search",
  LANDING_PAGE_ABSTRACT_CLICKED: "Landing Page - Abstract Clicked",
  ABSTRACT_DOWNLOADED: "Abstract Downloaded",
  DOCUMENT_DOWNLOADED: "Document Downloaded",
  ABSTRACT_DELETED: "Abstract Deleted",
  ABSTRACT_VIEWED: "Abstract Viewed",
  ABSTRACT_RETRIED: "Abstraction Retried",
  ACCOUNT_SETTINGS_PASSWORD_CHANGED: "Account Settings - Password Changed",
  ACCOUNT_SETTINGS_ACCOUNT_DELETED: "Account Settings - Account Deleted",
  ACCOUNT_SETTINGS_TRANSACTION_HISTORY_RECEIPT_VIEWED:
    "Account Settings - Transaction History - Receipt Viewed",
  ACCOUNT_SETTINGS_REFUND_REQUEST_OPENED:
    "Account Settings - Refund Request Opened",
  REFUND_REQUEST_SUBMITTED: "Refund Request Submitted",
  REFUND_REQUEST_REFUNDED: "Refund Request Refunded",
  BULK_ABSTRACT_DOWNLOAD: "Bulk Abstract Download",
  PROMO_CODES_USED: "Promo codes used",
  FILE_UPLOAD_ABSTRACT_GROUP_CREATED: "File Upload - Abstract Group Created",
  FILE_UPLOAD_ABSTRACT_GROUP_DELETED: "File Upload - Abstract Group Deleted",
  FILE_UPLOAD_ABSTRACT_GROUP_RENAMED: "File Upload - Abstract Group Renamed",
  ABSTRACT_RENAMED: "Abstract Renamed",
  DOCUMENT_VIEWER_OPENED: "Document Viewer -  Opened",
  DOCUMENT_VIEWER_CLOSED: "Document Viewer - Closed",
  DOCUMENT_VIEWER_DOCUMENT_ZOOMED: "Document Viewer - Document Zoomed",
  DOCUMENT_VIEWER_DOC_PAGE_NAVIGATED: "Document Viewer - Doc Page Navigated",
  DOCUMENT_VIEWER_BOOKMARK_CLICKED: "Document Viewer - Bookmark Clicked",
  DOCUMENT_VIEWER_BOOKMARK_TOGGLED: "Document Viewer - Bookmark Toggled",
  DOCUMENT_VIEWER_HIGHLIGHT_TOGGLED: "Document Viewer - Highlight Toggled",
  CUSTOM_TERM_CREATE_MODAL_OPENED: "Custom Term - Create Modal Opened",
  CUSTOM_TERM_CREATE_SAVED: "Custom Term - Create Saved",
};

export const PH_LOCATIONS = {
  LANDING_PAGE: "Landing Page",
  ABSTRACT_SUMMARY_PAGE: "Abstract Summary Page",
  DOCUMENT_HISTORY_DRAWER: "Document History Drawer",
  HISTORY_DRAWER: "History Drawer",
  ABSTRACT_DOCUMENT_MENU: "Abstract Document Menu",
  EDIT_ANNOTATION: "Edit Annotation",
};
